export default {

    text_child: '优中选优的好老师 让孩子爱学敢说',
    hot: '热情',
    nai: '耐心',
    zhun: '专属',
    fuze: '负责',

    benefit: '',
    benefit_one: '激发孩子学习兴趣',
    benefit_two: '让孩子自信说中文',
    benefit_three: '亦师亦友专属相伴',

    dream: '这里一定有你想要的中文教师',

    // dream遍历部分

    teache_title: '中文教育专家',

    // teache遍历内容

    introduc: '这里一定有你想要的中文教师',
    introduc_item1_title: '资历初选',
    introduc_item1_intro: '中文教育相关专业，对外汉语相关资格认证教师资格证普通话二甲以上英语六级以上 至少两年教学经验 至少两年教学经验',
    introduc_item2_title: '视频面试',
    introduc_item2_intro: '在线教学技巧、教材处理技巧 沟通能力鼓励学员思考、激发学员互动 综合知识能力具备多领域专业知识 至少两年教学经验',
    introduc_item3_title: '培训考核',
    introduc_item3_intro: '定期内部培训精益教学 哈兔自有教研体系高频研讨定期考核评定教师薪资和明星教师评比 至少两年教学经验',
    introduc_item4_title: '高效反馈',
    introduc_item4_intro: '根据学员需求、兴趣匹配最适合老师根据学员学习情况，及时调整教学方案 至少两年教学经验',

    how_title: '哈兔怎么样，家长有话说',

    teacher: '哈兔优质中文教师，助力成长每一步',
    teacher_extra: '爱孩子、懂孩子、专业、负责',

    parent: '哈兔怎么样，家长有话说',

    education: '中文教育专家',
    education_item1: '优质中文教师',
    education_item2: '本科以上学历',
    education_item3: '两年以上教学经验',
    education_item4: '懂心理爱孩子',

    year: '年对外汉语教学经验',

    teach_style: '教学风格',

    nationality: '中国'
}